import { Stack, Typography } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { Card } from '@/components/layout/Card/Card';
import { useAiSuggestionsMatcherContext } from '@/modules/aiSuggestions/AISuggestionsMatcher/context/aiSuggestionsMatcher.context';
import { useEditEntitySplitScreenModalContext } from '@/modules/entities/EditEntitySplitScreen/contexts/editEntitySplitScreenModal.context';
import { COLORS } from '@/styles/tokens/colors';

/**
 * For the current edit entity section, this component renders a card with a
 * portal ref for each array field that has duplicates.
 */
export function AISuggestionArrayFieldDuplicates() {
  const { duplicatesRefs } = useEditEntitySplitScreenModalContext();

  const {
    arrayFieldsWithDuplicates,
    matcherConfigs: { subformArrayFieldUpdateProps },
    duplicateSelections,
  } = useAiSuggestionsMatcherContext();

  return (
    <Stack direction="column" gap={1} sx={{ width: '100%' }}>
      {subformArrayFieldUpdateProps.map((arrayField) => {
        const ref = duplicatesRefs[arrayField.arrayFieldFullPath];
        const hasDuplicates =
          arrayFieldsWithDuplicates[arrayField.arrayFieldFullPath];
        const selection = duplicateSelections[arrayField.arrayFieldFullPath];

        if (!ref || !hasDuplicates) return null;

        return (
          <Card
            key={arrayField.arrayFieldFullPath}
            variant="outlined"
            sx={{
              p: 2,
              gap: 2,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'visible',
              borderRadius: '6px',
              borderColor: COLORS.TEAL['700'],
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack>
                <Typography variant="title-s" color={COLORS.TEAL['700']}>
                  {arrayField.duplicateGroupLabel}
                </Typography>
                <Typography variant="body-xs">
                  Select the entry you want to keep
                </Typography>
              </Stack>
              {selection && (
                <Button
                  size="sm"
                  variant="primary"
                  onClick={selection.onConfirm}
                  data-testid="confirm_duplicate_button"
                >
                  Confirm
                </Button>
              )}
            </Stack>
            <div ref={ref} />
          </Card>
        );
      })}
    </Stack>
  );
}
